import React from 'react';
import PropTypes from 'prop-types';
import {
  BooleanInput,
  TextInput,
  SimpleForm,
  required,
  usePermissions,
  useTranslate,
} from 'react-admin';
import { FormSpy } from 'react-final-form';
import {
  CleanerAutocompleteInput,
  LeaveSelectInput,
  EmptyInput,
  Toolbar,
} from '../../../../components';
import { dateValidation } from '../../../../helpers/date';
import { getUser } from '../../../../user';

import StartDateInput from './StartDateInput';
import EndDateInput from './EndDateInput';
import CleanerContractsAutocompleteInput from './CleanerContractsAutocompleteInput';

const validate = (values) => {
  return Object.assign({}, dateValidation(values));
};

const Form = ({ aside, ...props }) => {
  const translate = useTranslate();
  // Fail closed: rely on react-admin permissions, fall back to the stored
  // user while the async AUTH_GET_PERMISSIONS call hasn't resolved yet (same
  // repli pattern as Cleaner/detail/Form.js and
  // Vivier/components/WarningsCard.js).
  const { permissions } = usePermissions();
  const user = permissions || getUser();

  // Mirror the server-side check (postgRest.js: hasPermission(user, 'leave',
  // 'delete', 1)) instead of a hardcoded role test, same motif as
  // Cleaner/detail/Form.js. `isCreate` keeps the button off the Create
  // screen (this Form is shared by Leave/Create.js and Leave/Edit.js).
  const isCreate = !props.record || !props.record.id;
  const isDeletable = !isCreate && !!(user?.permissions?.leave?.delete >= 1);

  return (
    <SimpleForm
      {...props}
      redirect="show"
      validate={validate}
      toolbar={<Toolbar isDeletable={isDeletable} />}
    >
      <CleanerAutocompleteInput validate={[required()]} />
      <FormSpy subscription={{ valid: true, values: true }}>
        {({ values }) => {
          const cleanerId = values.cleaner_id ? values.cleaner_id : null;
          if (!cleanerId) {
            return (
              <EmptyInput
                variant="body1"
                label={translate('resources.cleaner.form.choose_cleaner')}
              />
            );
          }
          return <CleanerContractsAutocompleteInput cleanerId={cleanerId} />;
        }}
      </FormSpy>
      <StartDateInput />
      <EndDateInput />
      <LeaveSelectInput source="absence_type" validate={[required()]} />
      <BooleanInput source="processed" />
      <TextInput source="comment" />
      <FormSpy subscription={{ valid: true, values: true }}>
        {({ values }) => {
          const cleanerId = values.cleaner_id ? values.cleaner_id : null;

          return React.cloneElement(aside, { cleanerId });
        }}
      </FormSpy>
    </SimpleForm>
  );
};

Form.propTypes = {
  aside: PropTypes.element,
};

Form.defaultProps = {
  aside: null,
};

export default Form;
